<template>
    <span>
        <button
            class="btn"
            :class="{ active: deploying }"
            @click="generateQRCodes()"
        >
            <div><span class="icon-deploy"></span> Deploy</div>
        </button>

        <transition name="modal">
            <div
                v-show="qrCodes.length"
                class="qr-modal"
                @click.self="qrCodes = []"
            >
                <div class="qr-modal__content">
                    <p>{{ currentQRCode }} / {{ qrCodes.length }}</p>

                    <img
                        v-for="(qrCode, index) in qrCodes"
                        v-show="currentQRCode === index + 1"
                        :key="index"
                        :src="`data:image/png;base64, ${qrCode}`"
                    />

                    <a
                        href="#"
                        class="qr-modal__previous"
                        :class="{ active: hasPrevious }"
                        @click="prev()"
                    >
                        <span class="icon-chevron-left"></span>
                    </a>

                    <a
                        href="#"
                        class="qr-modal__next"
                        :class="{ active: hasNext }"
                        @click="next()"
                    >
                        <span class="icon-chevron-right"></span>
                    </a>
                </div>
            </div>
        </transition>
    </span>
</template>

<script>
export default {
    name: 'GenerateQrCodeAction',

    props: ['ids'],

    data() {
        return {
            currentQRCode: 1,
            qrCodes: [],
            deploying: false,
            errorResponse: null,
        }
    },

    computed: {
        hasPrevious() {
            return this.currentQRCode > 1
        },

        hasNext() {
            return this.currentQRCode < this.qrCodes.length
        },
    },

    methods: {
        generateQRCodes() {
            this.deploying = true

            setTimeout(() => {
                this.$http.post('frequency-sets/deploy', { 'frequency-sets': this.ids }).then(({ data }) => {
                    this.qrCodes = data
                    this.deploying = false
                })
            }, 500)
        },

        prev() {
            if (this.currentQRCode > 1) {
                this.currentQRCode -= 1
            }
        },

        next() {
            if (this.currentQRCode < this.qrCodes.length) {
                this.currentQRCode += 1
            }
        },
    },
}
</script>

<style scoped>
.qr-modal {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(100, 100, 100, 0.8);
    padding: 30px 45px;
    text-align: center;
    overflow-y: scroll;
}

.qr-modal__content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    max-width: 600px;
    margin: 0px auto;
    padding: 30px 30px 45px 30px;
    background-color: #000;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.qr-modal__content p {
    margin-bottom: 25px;
}

.qr-modal__content img {
    max-width: 100%;
}

.qr-modal__previous,
.qr-modal__next {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -32px;
    font-size: 4rem;
    color: #fff;
    opacity: 0.25;
    text-decoration: none;
}

.qr-modal__previous.active,
.qr-modal__next.active {
    opacity: 1;
}

.qr-modal__next {
    left: auto;
    right: 0;
}

.modal-enter-active {
    transition: opacity 0.2s;
}

.modal-enter {
    opacity: 0;
}
</style>
